import { Notify } from 'util/notify';

const OpenNotification = (option) => Notify[option.type]({ message: option.title });

export default OpenNotification;
